import { DatePipe } from "@angular/common";
import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from "app/auth/auth.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { BillingserviceService } from "../billingService.service";
import { CourierDetailsComponent } from "../courier-details/courier-details.component";
import { EmailToPartyComponent } from "../email-to-party/email-to-party.component";
import {
  PartyDetailModel,
  PartyDocumentDetail,
} from "../Models/corporatedetail.model";
import { IPDService } from "app/ipd/Services/ipdServices.service";

@Component({
  selector: "app-corporate-detail",
  templateUrl: "./corporate-detail.component.html",
  styleUrls: ["./corporate-detail.component.scss"],
})
export class CorporateDetailComponent implements OnInit {
  patientName: any;
  configArray: any = [];

  partydetaildocument: PartyDocumentDetail[] = [];

  currentStatusArray: any = [];
  insuranceCompanyArray: any = [];
  checklistdata: any = [];
  newInsuranceCompany: string = "";
  showspinner = false;
  showheader: boolean = true;
  @ViewChild('insuranceref', { static: false }) private InsuranceRef: ElementRef;

  constructor(
    public dialog: MatDialog,
    public dashboardService: DashboardService,
    public authService: AuthService,
    public ipdservice: IPDService,
    public billingservice: BillingserviceService,
    private datePipe: DatePipe,
    public opdvisitService: OpdVisitService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.showheader = true;
    this.dashboardService.subscriptions= this.ipdservice.share.subscribe((item) => {
      if (Object.keys(item).length != 0) {
        this.showheader = false;
        this.getPartyMasterConfiguration(item["fK_PartyId"]);
        this.GetCheckListData(item["fK_PartyId"]);
        this.data.billId = 0;
        this.data.ipdId = item["pK_IPDId"];
        this.data.balanceAmount = 0;
        this.data.screentype='ipd';
        this.data.partyip = item["fK_PartyId"];
        const partyid = this.data.partyip;
        this.opdvisitService.patientdetails.pkRegId = item["fK_RegId"];
        this.getCorporatedetails(0, item["pK_IPDId"],item["fK_RegId"],0);
        this.patientName = item["patientName"];
      } else {
     
        const partyid = this.data.partyip;
        this.getPartyMasterConfiguration(partyid);
        if(this.data.screentype=='Billing'){
          this.getCorporatedetails(this.data.billId, 0, 0,0);
        }else if(this.data.screentype=='counselor'){
          this.getCorporatedetails(0, 0, 0,this.data.counsid);
        }
       
        this.GetCheckListData(partyid);
        this.patientName =
          this.opdvisitService?.patientdetails?.firstName +
          " " +
          this.opdvisitService?.patientdetails?.lastName;
      }
    });
    this.billingservice.partytp = {};

    this.GetCurrentStatus();
    this.GetInsuranceCompany();
  }

  // checklist data from configuration
  GetCheckListData(partyid) {
    this.checklistdata = [];
    this.dashboardService.subscriptions=  this.billingservice.GetChecklist(partyid).subscribe((item) => {
      this.checklistdata = item;
    });
  }
  GetCurrentStatus() {
    this.currentStatusArray = [];
    this.dashboardService.subscriptions= this.billingservice.GetCurrentStatus().subscribe((item) => {
      this.currentStatusArray = item;
    });
  }
  GetInsuranceCompany() {
    this.insuranceCompanyArray = [];
    this.dashboardService.subscriptions=  this.billingservice.GetInsuranceCompany().subscribe((item) => {
      this.insuranceCompanyArray = item;
    });
  }
  AddInsuranceCompany() {
    document.getElementById("addInsuranceModel").style.display = "block";
  }
  // add and update insurace company data
  companyUpdate() {
    const filterdata = this.insuranceCompanyArray.filter(
      (item) =>
        item.insuranceCoName.toLowerCase() ==
        this.newInsuranceCompany.toLowerCase()
    );

    if (filterdata.length > 0) {
      this.dashboardService.openSnackBar(
        "This Company is Already Exist in DropDown List Please Select",
        "OK"
      );

      document.getElementById("addInsuranceModel").style.display = "none";
      this.GetInsuranceCompany();
    } else {
      if (this.newInsuranceCompany != null && this.newInsuranceCompany != "") {
        const adddata = {
          InsuranceCoName: this.newInsuranceCompany,
          CodeNo: 638,
          IsActive: 1,
          PK_InsuranceCoId: 0,
        };
        this.showspinner = true;
        this.dashboardService.subscriptions= this.billingservice.AddInsuranceComapny(adddata).subscribe((item) => {
          this.showspinner = false;
          this.dashboardService.openSnackBar(
            "Successfully Add Insurance Company",
            "OK"
          );
          document.getElementById("addInsuranceModel").style.display = "none";
          this.GetInsuranceCompany();
        });
      } else {
        this.dashboardService.openSnackBar("Please Enter Company Name", "OK");
      }
    }
  }

  closeModificationModalDialog() {
    document.getElementById("addInsuranceModel").style.display = "none";
  }
  closedialog() {
    this.dialog.closeAll();
  }
  // set configuration in corporate detail
  getPartyMasterConfiguration(partyid) {
    this.dashboardService.subscriptions= this.billingservice.GetPartyByPartyId(partyid).subscribe((dataa) => {
      if (dataa.length > 0) {
        this.billingservice.partytp = dataa[0];
        //  this.partyNameTPA = this.billingservice.partytp?.partyName;
      } else {
        this.billingservice.partytp = {};
        // this.billingservice.partytp.partyName=null;
        //  this.partyNameTPA = this.billingservice.partytp?.partyName;
      }
    });
  }
  // call new corporate detail binding
  setCorporatedata() {
    const newdate = this.authService.getServerDate;
    this.billingservice.partydetail.ReportDate = this.datePipe.transform(
      newdate,
      "yyyy-MM-dd"
    );
    this.billingservice.partydetail.ClaimDate = this.datePipe.transform(
      newdate,
      "yyyy-MM-dd"
    );
    this.billingservice.partydetail.SanctionDate = this.datePipe.transform(
      newdate,
      "yyyy-MM-dd"
    );
    this.billingservice.partydetail.ReferralDate = this.datePipe.transform(
      newdate,
      "yyyy-MM-dd"
    );
    this.billingservice.partydetail.ClaimAmount = this.data.balanceAmount;
    this.billingservice.partydetail.PK_PartyDetailId = 0;
    if(this.data.screentype=='counselor'){
      this.billingservice.partydetail.FK_CounselorId = this.data.counsid;
    }else{
      this.billingservice.partydetail.FK_CounselorId = 0;
    }
    this.billingservice.partydetail.FK_BillId = this.data.billId;
    this.billingservice.partydetail.FK_InsuranceCoId = 0;
    this.billingservice.partydetail.ReferralReason = "";
    this.billingservice.partydetail.SanctionAmount = 0;
    this.billingservice.partydetail.DifferenceAmount = 0;
    this.billingservice.partydetail.CoPayment = 0;
    this.billingservice.partydetail.EmployeeName = "";
    this.billingservice.partydetail.EmployeeIPNo = "";
    this.billingservice.partydetail.Relation = "";
    this.billingservice.partydetail.Remarks =
      this.billingservice.partytp?.remarks;
    this.billingservice.partydetail.EmmergencyInformed = 0;
    this.billingservice.partydetail.MOUDiscount = 0;
    this.billingservice.partydetail.A = "";
    this.billingservice.partydetail.B = "";
    this.billingservice.partydetail.C = "";
    this.billingservice.partydetail.D = "";
    this.billingservice.partydetail.E = "";
    this.billingservice.partydetail.F = "";
    this.billingservice.partydetail.G = "";
    this.billingservice.partydetail.H = "";
    this.billingservice.partydetail.CurrentStatus = " ";
    this.billingservice.partydetail.PK_SynchId = null;
    this.billingservice.partydetail.SanctionAmount2 = 0;
    this.billingservice.partydetail.SanctionAmount3 = 0;
    this.billingservice.partydetail.SanctionDate2 = null;
    this.billingservice.partydetail.SanctionDate3 = null;
    this.billingservice.partydetail.Copaymenttype = this.data.partyip;
    this.billingservice.partydetail.copaymentperc = 0;
    this.billingservice.partydetail.fk_IPDId = this.data.ipdId;
  }
  // save and update corporate detail
  InsuranceValidation:boolean = false;
  SaveCorporateDetail() {
    // if (this.billingservice.partydetail.FK_BillId > 0 ) {
    if (
      this.billingservice.partydetail.FK_InsuranceCoId == null ||
      this.billingservice.partydetail.FK_InsuranceCoId == 0
    ) {
      this.InsuranceValidation= true;      
          setTimeout(() => {
            this.InsuranceRef.nativeElement.focus();
          }, 100);
      this.dashboardService.openSnackBar(
        "Please Select Insurance Company",
        "OK"
      );
      return;
    }
    // if (this.billingservice.partydetail.ReferralDate == null) {
    //   this.dashboardService.openSnackBar("Please Referral Date", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.ReportDate == null) {
    //   this.dashboardService.openSnackBar("Please Select Report Date", "OK");
    //   return;
    // }

    // if (this.billingservice.partydetail.ReferralReason == null || this.billingservice.partydetail.ReferralReason == "") {
    //   this.dashboardService.openSnackBar("Please Enter Ref. Reason", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.ClaimAmount == null) {
    //   this.dashboardService.openSnackBar("Please Enter Claim Amount", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.SanctionDate == null) {
    //   this.dashboardService.openSnackBar("Please Select Sanction Date", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.SanctionAmount == null) {
    //   this.dashboardService.openSnackBar("Please Enter Sanction Amount", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.CoPayment == null) {
    //   this.dashboardService.openSnackBar("Please Enter Co Payment", "OK");
    //   return;

    // }
    // if (this.billingservice.partydetail.DifferenceAmount == null) {
    //   this.dashboardService.openSnackBar("Please Enter Difference Amount", "OK");
    //   return;

    // }
    // if (this.billingservice.partydetail.EmployeeName == null || this.billingservice.partydetail.EmployeeName == "") {
    //   this.dashboardService.openSnackBar("Please Enter Employee Name", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.Relation == null || this.billingservice.partydetail.Relation == "") {
    //   this.dashboardService.openSnackBar("Please Enter Relation With ESM", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.EmployeeIPNo == null || this.billingservice.partydetail.EmployeeIPNo == "") {
    //   this.dashboardService.openSnackBar("Please Enter Insurance P.No", "OK");
    //   return;
    // }
    // if (this.billingservice.partydetail.Remarks == null || this.billingservice.partydetail.Remarks == "") {
    //   this.dashboardService.openSnackBar("Please Enter Remarks", "OK");
    //   return;
    // }

    // if (this.billingservice.partytp.a == '') {
    //   this.billingservice.partydetail.A = "";
    // } else if (this.billingservice.partytp.a != '' && (this.billingservice.partydetail.A == "" || this.billingservice.partydetail.A == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.a, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.b == '') {
    //   this.billingservice.partydetail.B = "";
    // } else if (this.billingservice.partytp.b != '' && (this.billingservice.partydetail.B == "" || this.billingservice.partydetail.B == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.b, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.c == '') {
    //   this.billingservice.partydetail.C = "";
    // } else if (this.billingservice.partytp.c != '' && (this.billingservice.partydetail.C == "" || this.billingservice.partydetail.C == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.c, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.d == '') {
    //   this.billingservice.partydetail.D = "";
    // } else if (this.billingservice.partytp.d != '' && (this.billingservice.partydetail.D == "" || this.billingservice.partydetail.D == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.d, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.e == '') {
    //   this.billingservice.partydetail.E = "";
    // } else if (this.billingservice.partytp.e != '' && (this.billingservice.partydetail.E == "" || this.billingservice.partydetail.E == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.e, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.f == '') {
    //   this.billingservice.partydetail.F = "";
    // } else if (this.billingservice.partytp.f != '' && (this.billingservice.partydetail.F == "" || this.billingservice.partydetail.F == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.f, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.g == '' || this.billingservice.partydetail.G == null) {
    //   this.billingservice.partydetail.G = "";
    // } else if (this.billingservice.partytp.g != '' && (this.billingservice.partydetail.G == "" || this.billingservice.partydetail.G == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.g, "OK");
    //   return;
    // }
    // if (this.billingservice.partytp.h == '' || this.billingservice.partydetail.H == null) {
    //   this.billingservice.partydetail.H = "";
    // } else if (this.billingservice.partytp.h != '' && (this.billingservice.partydetail.H == "" || this.billingservice.partydetail.H == null)) {
    //   this.dashboardService.openSnackBar("Please Enter " + this.billingservice.partytp.h, "OK");
    //   return;
    // }
    this.billingservice.partydetail.PK_SynchId = null;
    this.billingservice.partydetail.SanctionAmount2 = 0;
    this.billingservice.partydetail.SanctionAmount3 = 0;
    this.billingservice.partydetail.SanctionDate2 = null;
    this.billingservice.partydetail.SanctionDate3 = null;
    this.billingservice.partydetail.Copaymenttype = this.data.partyip;
    this.billingservice.partydetail.copaymentperc = 0;
    this.billingservice.partydetail.fk_IPDId = this.data.ipdId;
    const arraydata = {
      PartyDetail: this.billingservice.partydetail,
      PartyDocumentDetail: this.partydetaildocument,
    };
    this.showspinner = true;
    this.dashboardService.subscriptions= this.billingservice.InsertPartyCompany(arraydata).subscribe((item) => {
      this.showspinner = false;
      if (this.billingservice.partydetail.PK_PartyDetailId > 0) {
        if (item.id > 0) {
          if(this.data.screentype=='Billing'){
            this.getCorporatedetails(this.data.billId, 0, 0,0);
          }else if(this.data.screentype=='counselor'){
            this.getCorporatedetails(0, 0, this.opdvisitService.patientdetails.pkRegId,this.data.counsid);
          }else{
            this.getCorporatedetails(0, this.data.ipdId,0,0);
          }
         
          this.dashboardService.openSnackBar(
            "Insurance Details Updated Successfully",
            "OK"
          );
        } else {
          this.dashboardService.openSnackBar("Api Failed  ", "OK");
        }
      } else {
        if (item.id > 0) {
          if(this.data.screentype=='Billing'){
            this.getCorporatedetails(this.data.billId, 0, 0,0);
          }else if(this.data.screentype=='counselor'){
            this.getCorporatedetails(0, 0, 0,this.data.counsid);
          }else{
            this.getCorporatedetails(0, this.data.ipdId,0,0);
          }
          this.dashboardService.openSnackBar(
            "Insurance Details Saved Successfully",
            "OK"
          );
        } else {
          this.dashboardService.openSnackBar("Api Failed  ", "OK");
        }
      }
    },err=>{
      this.showspinner = false;
          this.dashboardService.openSnackBar("Api Failed  ", "OK");
    });
    // }
  }

  getCorporatedetails(billid, ipdId,regid,counid) {
    this.billingservice.partydetail = {};
    this.showspinner = true;
    this.dashboardService.subscriptions= this.billingservice
      .GetPartyDetailByBIllId(billid, ipdId,regid,counid)
      .subscribe((item) => {
        //get bindingdata
        this.showspinner = false;
        if (item.pK_PartyDetailId != null) {
          this.billingservice.partydetail.ReportDate = this.datePipe.transform(
            item.reportDate,
            "yyyy-MM-dd"
          );
          this.billingservice.partydetail.ClaimDate = this.datePipe.transform(
            item.claimDate,
            "yyyy-MM-dd"
          );
          this.billingservice.partydetail.SanctionDate =
            this.datePipe.transform(item.sanctionDate, "yyyy-MM-dd");
          this.billingservice.partydetail.ReferralDate =
            this.datePipe.transform(item.referralDate, "yyyy-MM-dd");
          this.billingservice.partydetail.ClaimAmount = item.claimAmount;
          this.billingservice.partydetail.PK_PartyDetailId =
            item.pK_PartyDetailId;
          this.billingservice.partydetail.FK_CounselorId = item.fK_CounselorId;
          this.billingservice.partydetail.FK_BillId = item.fK_BillId;
          this.billingservice.partydetail.FK_InsuranceCoId =
            item.fK_InsuranceCoId;
          this.billingservice.partydetail.ReferralReason = item.referralReason;
          this.billingservice.partydetail.SanctionAmount = item.sanctionAmount;
          this.billingservice.partydetail.DifferenceAmount =
            item.differenceAmount;
          this.billingservice.partydetail.CoPayment = item.coPayment;
          this.billingservice.partydetail.EmployeeName = item.employeeName;
          this.billingservice.partydetail.EmployeeIPNo = item.employeeIPNo;
          this.billingservice.partydetail.Relation = item.relation;
          this.billingservice.partydetail.Remarks = item.remarks;
          this.billingservice.partydetail.EmmergencyInformed =
            item.emmergencyInformed;
          this.billingservice.partydetail.MOUDiscount = item.mouDiscount;
          this.billingservice.partydetail.A = item.a;
          this.billingservice.partydetail.B = item.b;
          this.billingservice.partydetail.C = item.c;
          this.billingservice.partydetail.D = item.d;
          this.billingservice.partydetail.E = item.e;
          this.billingservice.partydetail.F = item.f;
          this.billingservice.partydetail.G = item.g;
          this.billingservice.partydetail.H = item.h;
          this.billingservice.partydetail.CurrentStatus = item.currentStatus;
          this.billingservice.partydetail.PK_SynchId = item.pK_SynchId;
          this.billingservice.partydetail.SanctionAmount2 =
            item.sanctionAmount2;
          this.billingservice.partydetail.SanctionAmount3 =
            item.sanctionAmount3;
          this.billingservice.partydetail.SanctionDate2 = item.sanctionDate2;
          this.billingservice.partydetail.SanctionDate3 = item.sanctionDate3;
          this.billingservice.partydetail.Copaymenttype = item.copaymenttype;
          this.billingservice.partydetail.copaymentperc = item.copaymentperc;
          this.billingservice.partydetail.fk_IPDId = item.fk_IPDId;
        } else {
          this.setCorporatedata();
        }
      });
  }
  addCouriorDetail() {
    //if(this.opdvisitService.patientdetails.pkRegId >0){

    const dialogRef1 = this.dialog.open(CourierDetailsComponent, {
      // panelClass: "full-width-dialog",
      // maxWidth: "100vw !important",
      // height: "55%",
      width: "90%",
    });

    this.dashboardService.subscriptions= dialogRef1.afterClosed().subscribe((result) => {});
    // }else{
    //    this.dashboardService.openSnackBar(" Please Enter Patient Id First ", "OK");
    // }
  }

  /* Email to Party popup */
  emailToParty() {
    const dialogRef1 = this.dialog.open(EmailToPartyComponent, {
      // panelClass: "full-width-dialog",
      maxWidth: "90vw !important",
      // height: "80%",
      width: "90%",
    });

    this.dashboardService.subscriptions=  dialogRef1.afterClosed().subscribe((result) => {});
  }
  validateNo(e: any, checkcation: any, length: number): boolean {
  
    if (
      checkcation == "Aadhaar No" ||
      checkcation == "Adhar" ||
      checkcation == "Aadhaar"
    ) {
      if (e.target.value.length == 12) {
        return false;
      }
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }
}
